import { render, staticRenderFns } from "./psychicDuels.vue?vue&type=template&id=3c318a0a&scoped=true&"
import script from "./psychicDuels.vue?vue&type=script&lang=js&"
export * from "./psychicDuels.vue?vue&type=script&lang=js&"
import style0 from "./psychicDuels.vue?vue&type=style&index=0&id=3c318a0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c318a0a",
  null
  
)

export default component.exports